import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { EmailSacado } from '../_models/titulo/emailSacado';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { FilterCedente } from '../_models/filter/filterCedente';
import { HistoricoEmailDisplay } from '../_models/titulo/historicoEmailDisplay';
import { ListaPagamentoDTO } from '../_models/titulo/ListaPagamentoDTO';


export const HTTP_OPTIONS = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Access-Control-Allow-Credentials' : 'true',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PATCH, DELETE, PUT, OPTIONS',
    'Access-Control-Allow-Headers': 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
  })
};


@Injectable({ providedIn: 'root' })
export class EmailSacadoService {

  constructor(private http: HttpClient) { }

sendEmail(emailSacado: EmailSacado): Observable<EmailSacado> {
  return this.http.post<EmailSacado>(`${environment.authorizedUrls.bsCobrancaUrl}/email/sendMail`, {emailSacado}).pipe(
    tap((newEmailSacado: EmailSacado) => console.log(`sent new e-mail w/ id=${newEmailSacado.codEmailSacado}`)),
    catchError(this.handleError<EmailSacado>('sendEmail'))
  );
 }

 sendEmailList(emailSacadoList: EmailSacado[]): Observable<EmailSacado[]> {
    return this.http.post<EmailSacado[]>
    (
        `${environment.authorizedUrls.bsCobrancaUrl}/email/sendMailList`,
        {emailSacadoList}
    )
    .pipe
    (
      tap((newEmailSacadoList: EmailSacado[]) => console.log(`sent new e-mail w/ id=${newEmailSacadoList}`)),
      catchError(this.handleError<EmailSacado[]>('sendEmail'))
    );
   }

   getHistoricoEmail(filterCedente: FilterCedente): Observable<any> {
        return this.http.post<HistoricoEmailDisplay[]>(`${environment.authorizedUrls.bsCobrancaUrl}/historicoemail/listFiltro`, {
        filterCedente,
      });
    }

    getImageTitulo(codSacado: number): Observable<Blob> {
      return this.http.get(`${environment.authorizedUrls.bsCobrancaUrl}/email/image/` + codSacado, {responseType: 'blob'});
    }

	getPdfTitulo(codSacado: number): Observable<Blob> {
      return this.http.get(`${environment.authorizedUrls.bsCobrancaUrl}/email/pdf/` + codSacado, {responseType: 'blob'});
    }

    getPdfLote(titulos: ListaPagamentoDTO) {
      return this.http.post(`${environment.authorizedUrls.bsCobrancaUrl}/email/pdf/lote`, JSON.stringify(titulos), {
        headers: {'Content-Type': 'application/json'},
        responseType: 'blob' as 'json',
        observe: 'response'
      });
    }

   handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  exportarRelatorioClicks(filterCedente: FilterCedente){
    return this.http.post(`${environment.authorizedUrls.bsCobrancaUrl}/historicoemail/exportarClicks`, {
      filterCedente
    }, {responseType: 'blob' as 'json'})
  }

}
